import {DataObjectId, Hub} from 'yougile-model'
import {Sync} from '@client/sync'

export const getTaskOrFromNews = (taskId?: DataObjectId): Hub | undefined => {
  if (!taskId) {
    return undefined
  }

  const task = Sync.getCurrentSandbox().getHub(taskId)
  if (task) {
    return task
  }

  const newsTask = Sync.newsSandbox?.getHub(taskId)
  if (newsTask) {
    return newsTask
  }

  return undefined
}
